<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2756 1.60845C13.5197 1.36437 13.5197 0.96864 13.2756 0.724562C13.0315 0.480484 12.6358 0.480484 12.3917 0.724562L7.00033 6.11597L1.60893 0.724565C1.36486 0.480487 0.969128 0.480487 0.72505 0.724565C0.480973 0.968642 0.480973 1.36437 0.72505 1.60845L6.11645 6.99985L0.725073 12.3912C0.480995 12.6353 0.480995 13.031 0.725073 13.2751C0.969151 13.5192 1.36488 13.5192 1.60896 13.2751L7.00034 7.88373L12.3917 13.2751C12.6358 13.5192 13.0315 13.5192 13.2756 13.2751C13.5197 13.031 13.5197 12.6353 13.2756 12.3912L7.88422 6.99985L13.2756 1.60845Z"
      fill="white"
      fill-opacity="0.6"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "VectorIcon",
})
</script>
